import React, { useState, useEffect, memo } from "react";
import { callPostApi } from "../../api/ApiCaller.js";
import DataTable from "react-data-table-component";
import { MODAL_LOADER, SECTION_LOADER } from "utils/constants.js";
// npm i react-data-table-component
// npm i styled-components
const PaginationDataTable = (props) => {
    const {
        paginationUrl,
        serverSidePagination,
        columns,
        filter,
        search,
        pagination,
        defaultSortFieldId, 
        defaultSortDirection,
    } = props;
    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [filterText, setFilterText] = useState("");
    const resetPaginationToggle = false;

    useEffect(() => {
        var jsonRequest = {
            pageNumber: currentPage - 1,
            pageSize: perPage,
            search: filterText,
        };
        callPostApi(
            props.modalLoader ? MODAL_LOADER : SECTION_LOADER,
            paginationUrl,
            jsonRequest,
            {},
            (response) => {
                if (serverSidePagination) {
                    setData(response.responsePacket.data);
                    setTotalRows(response.responsePacket.totalItems);
                } else {
                    const res = response.responsePacket;
                    if (filter) {
                        const filteredItems = res.filter(
                            (item) =>
                                item.title &&
                                item.title
                                    .toLowerCase()
                                    .includes(filterText.toLowerCase())
                        );
                        setData(filteredItems);
                    } else {
                        setData(res);
                    }
                    setTotalRows(response.responsePacket.length);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [
        paginationUrl,
        serverSidePagination,
        columns,
        filter,
        perPage,
        currentPage,
        filterText,
    ]);

    const handleChange = (e) => {
        setCurrentPage(1);
        setFilterText(e.target.value);
    };

    const subHeaderComponentMemo = () => {
        return (
            <div className="custom-table-header">
                <div className="input-group mb-3 paginationSearchInput">
                    <div className="input-group-prepend">
                        <span className="input-group-text">
                            <i className="bx bx-search"></i>
                        </span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={filterText}
                        onChange={handleChange}
                    />
                </div>
            </div>
        );
    };

    const customStyles = {
        headCells: {
            style: {
                color: "#9f9f9f", // override the cell padding for head cells
                fontWeight: "600",
            },
        },
    };

    return serverSidePagination ? (
        <DataTable
            className="custom-data-table"
            title=""
            subHeader={search}
            subHeaderComponent={search && subHeaderComponentMemo()}
            columns={columns}
            data={data}
            // progressPending={loading}
            // progressComponent={<Loader />}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            onChangeRowsPerPage={(e) => setPerPage(e)}
            onChangePage={(e) => setCurrentPage(e)}
            customStyles={customStyles}
            striped={true}
            defaultSortFieldId={defaultSortFieldId}
            defaultSortAsc={defaultSortDirection === "asc"}
            /* selectableRows onSelectedRowsChange={({ selectedRows }) => console.log(selectedRows)} */
        />
    ) : (
        <DataTable
            className="custom-data-table"
            title=""
            columns={columns}
            data={data}
            pagination={pagination}
            subHeader={search}
            subHeaderComponent={search && subHeaderComponentMemo()}
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            paginationResetDefaultPage={resetPaginationToggle}
            defaultSortFieldId={defaultSortFieldId}
            defaultSortAsc={defaultSortDirection === "asc"}
            // fixedHeader = {true}
            // progressPending={loading}
            // progressComponent={<Loader />}
            /* selectableRows onSelectedRowsChange={({ selectedRows }) => console.log(selectedRows)} */
        />
    );
};

export default memo(PaginationDataTable);
